// eslint-disable-next-line max-len
export const EMAIL_REGEX =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}])|(([a-zA-Z\-\d]+\.)+[a-zA-Z]{2,}))$/;
export const MOBILE_PHONE_REGEX = /^(\+61|0)4(\d[\s-]*){8}$/i;
export const NAME_REGEX = /^[A-Za-z- ]+$/;
export const POSTAL_CODE_REGEX = /\b\d{4}\b/;
export const SANITISE_REGEX = /[^a-zA-Z0-9\s.,!@#$%^&*()+={}[\]:;"'`-]/g;
